/**
 * HOC handle `failure` prop by wrapping page components.
 */
import * as React from 'react';
import { useState } from 'react';

import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import Cookies from 'universal-cookie';

import { PageProps } from '@/types/_app';

const withPasswordProtection = (WrappedComponent: InferGetServerSidePropsType<GetServerSideProps<any>>) => {
    const PasswordProtection = (props: PageProps) => {
        const cookies = new Cookies();
        const [isAuthenticated, setIsAuthenticated] = useState<undefined | boolean>(undefined);
        const [password, setPassword] = useState('');

        if (isAuthenticated === true) {
            return <WrappedComponent {...props} />;
        }

        const login = () => {
            if (password === 'blockw0rks') {
                cookies.set('bw-pw-protection', 'authenticated', { path: '/' });
                setIsAuthenticated(true);
            }
        };

        return (
            <>
                <div className="bg-white border border-gray-500 sm:rounded-lg max-w-md my-24 mx-auto">
                    <div className="px-4 py-5 sm:p-6">
                        <h3 className="text-lg font-medium leading-6 text-gray-900">Protected</h3>
                        <div className="mt-2 max-w-xl text-sm text-gray-500">
                            <p>This site is password protected.</p>
                        </div>
                        <form className="mt-5 sm:flex sm:items-center">
                            <div className="w-full sm:max-w-xs">
                                <label htmlFor="email" className="sr-only">
                                    Password
                                </label>
                                <input
                                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-black focus:ring-black sm:text-sm"
                                    type="text"
                                    value={password}
                                    onChange={ev => setPassword(ev.target.value)}
                                />
                            </div>
                            <button
                                onClick={login}
                                type="submit"
                                className="mt-3 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-black px-4 py-2 font-medium text-white shadow-sm hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            >
                                Login
                            </button>
                        </form>
                    </div>
                </div>
            </>
        );
    };
    return PasswordProtection;
};

export default withPasswordProtection;
